<template>
  <div class='hezuo_con'>
    <div class='pub_top_block w_1200 cooperate_pub_top_block'>
      <dl>
        <dt>
          <h3>{{ $t('home.channel.detail.title') }}</h3>
          <div class='text' v-html='$t("home.channel.detail.desc")'></div>
        </dt>
        <dd>
          <router-link to='/business-cooperate?from=joinButton' class='more more2'>{{ $t('home.channel.detail.join') }}</router-link>
        </dd>
      </dl>
      <img src='@/assets/img/photo_cppperation@2x.png' alt='' class='bg cooperate_banner'>
    </div>
    <div v-for='(item, index) in list' :key='index' :class='`block${index % 2 === 0 ? 4 : 3}`'>
      <div class='w_1200'>
        <div class='pub_tit'>{{ item.title }}</div>
        <div class='info text_center'>{{ item.desc }}</div>
        <ul class='fz_0 text_center'>
          <li v-for='(imgItem, imgIndex) in item.image' :key='imgIndex' class='img_box'>
            <img :src='imgItem' alt=''>
          </li>
        </ul>
      </div>
    </div>
    <!-- 子底部模块 -->
    <pub-bottom />
  </div>
</template>

<script>
import { setTitle } from 'utils'
import { listHandler } from '@/utils/variable'
import PubBottom from '@/components/PubBottom'

export default {
  name: 'BusinessCooperate',
  components: { PubBottom },
  data () {
    return {
    }
  },
  computed: {
    list () {
      // 不根据语言版切换的初始数据
      let list = [
        {
          image: [
            require('@/assets/icons/ic_logo_jd@2x.png'),
            require('@/assets/icons/ic_logo_tianmao@2x.png'),
            require('@/assets/icons/ic_logo_dd@2x.png'),
          ],
        },
        {
          image: [
            require('@/assets/icons/ic_logo_douyin@2x.png'),
            require('@/assets/icons/ic_logo_wechat@2x.png'),
            require('@/assets/icons/ic_logo_weibo@2x.png'),
            require('@/assets/icons/ic_logo_dd@2x.png'),
          ],
        },
        {
          image: [
            require('@/assets/icons/ic_logo_alibaba@2x.png'),
            require('@/assets/icons/ic_logo_tianmao2@2x.png'),
            require('@/assets/icons/ic_logo_weidian@2x.png'),
            require('@/assets/icons/ic_logo_hb@2x.png'),
            require('@/assets/icons/ic_logo_yunji@2x.png'),
            require('@/assets/icons/ic_logo_dav@2x.png'),
            require('@/assets/icons/ic_logo_youzan@2x.png'),
            require('@/assets/icons/ic_logo_miya@2x.png'),
            require('@/assets/icons/ic_logo_dalingjia@2x.png'),
          ],
        },
        {
          image: [
            require('@/assets/icons/Group19@2x.png'),
            require('@/assets/icons/Group20@2x.png'),
            require('@/assets/icons/Group21@2x.png'),
          ],
        },
        {
          image: [
            require('@/assets/icons/Group22@2x.png'),
            require('@/assets/icons/Group23@2x.png'),
          ],
        },
      ]
      // 结合语言版本进行初始化数据
      return listHandler.call(this, list, 'home.channel.detail.list')
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.navigation.bussiniss')}`)
  },
}
</script>
